import { render } from "./GutenbergVideo.vue?vue&type=template&id=31ee1196&scoped=true"
import script from "./GutenbergVideo.vue?vue&type=script&lang=js"
export * from "./GutenbergVideo.vue?vue&type=script&lang=js"

import "./GutenbergVideo.vue?vue&type=style&index=0&id=31ee1196&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ee1196"]])

export default __exports__